/**
 * Hook into Alpine so that it is available no matter at which point Alpine loads.
 */
document.addEventListener('alpine:init', () => {
    /**
     * Object to manage the removing confirmation dialog and send request for removing canceled order.
     */
    Alpine.data('canceledItem', () => ({
        /**
         * @var bool true when Dialog popup is showing.
         */
        isDialogOpen: false,

        /**
         * @var bool true when removed process is running.
         */
        loading: false,

        /**
         * Show the confirmation dialog.
         *
         * @return void
         */
        show() {
            this.isDialogOpen = true;
        },

        /**
         * Hide the confirmation dialog.
         *
         * @return void
         */
        hide() {
            this.isDialogOpen = false;
        },

        /**
         * Check if confirmation dialog is open.
         *
         * @return boolean
         */
        isOpen() {
            return this.isDialogOpen;
        },

        /**
         * Check if the removing request is loading.
         *
         * @return boolean
         */
        isLoading() {
            return this.loading;
        },

        /**
         * Remove order by order ID.
         *
         * @return void
         */
        remove(orderId) {
            this.hide();
            this.loading = true;

            this.$wire.deleteOrderAndReInitNeedsAttention(orderId).then(() => {
                this.loading = false;
            });
        }
    }));
});
